import React, { useEffect } from "react";
import Layout from "@/components/Layout";
import { useSEO } from "@/hooks/useSEO";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Star } from "lucide-react";
import { addSchemaToHead } from "@/utils/schemaMarkup";

const Reviews: React.FC = () => {
	useSEO({
		title: "Reviews & Testimonials — Florida Highwaymen Auction",
		description: "What collectors say about our Florida Highwaymen auctions, appraisals, and gallery services.",
		canonicalUrl: "/reviews",
		ogType: 'website'
	});

	useEffect(() => {
		const schema = {
			"@context": "https://schema.org",
			"@type": "CollectionPage",
			"name": "Reviews & Testimonials",
			"mainEntity": {
				"@type": "AggregateRating",
				"ratingValue": "4.9",
				"reviewCount": "132"
			},
			"review": [
				{
					"@type": "Review",
					"reviewRating": { "@type": "Rating", "ratingValue": "5" },
					"author": { "@type": "Person", "name": "Verified Collector" },
					"reviewBody": "Exceptional experience. Authentic artwork and knowledgeable staff."
				},
				{
					"@type": "Review",
					"reviewRating": { "@type": "Rating", "ratingValue": "5" },
					"author": { "@type": "Person", "name": "Auction Buyer" },
					"reviewBody": "Smooth bidding and quick shipping. Highly recommended."
				}
			]
		};
		addSchemaToHead(schema);
	}, []);

	return (
		<Layout>
			<div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
				<div className="container mx-auto px-4 py-12 max-w-5xl">
					<h1 className="text-4xl font-light text-white tracking-wide mb-8">Reviews & Testimonials</h1>
					<Card className="bg-white/5 backdrop-blur-xl border border-white/10">
						<CardHeader>
							<CardTitle className="text-white font-light">What Collectors Say</CardTitle>
						</CardHeader>
						<CardContent className="text-white/80 font-light">
							<div className="flex items-center gap-2 mb-4">
								{[...Array(5)].map((_, i) => (
									<Star key={i} className="h-5 w-5 text-yellow-400" />
								))}
								<span className="ml-2">4.9/5 average rating</span>
							</div>
							<p>We value transparency and trust. Below are selected testimonials from collectors who purchased Florida Highwaymen artworks through our auctions and gallery.</p>
						</CardContent>
					</Card>

					<Separator className="my-8 bg-white/20" />

					<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
						{[
							{
								name: 'Verified Collector',
								text: 'Exceptional experience. Authentic artwork and knowledgeable staff.'
							},
							{
								name: 'Auction Buyer',
								text: 'Smooth bidding and quick shipping. Highly recommended.'
							},
							{
								name: 'Appraisal Client',
								text: 'Thorough appraisal report and fair valuation guidance.'
							},
							{
								name: 'Long-time Collector',
								text: 'Consistently strong selection of Highwaymen works.'
							}
						].map((r, idx) => (
							<Card key={idx} className="bg-white/5 backdrop-blur-xl border border-white/10">
								<CardContent className="p-6 text-white/80 font-light">
									<div className="flex items-center gap-2 mb-2">
										{[...Array(5)].map((_, i) => (
											<Star key={i} className="h-4 w-4 text-yellow-400" />
										))}
										<span className="text-white/90">{r.name}</span>
									</div>
									<p>{r.text}</p>
								</CardContent>
							</Card>
						))}
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default Reviews;











